"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageInputAtComponent = exports.MessageInputAtSuggestion = void 0;
var vue_1 = require("vue");
var at_svg_1 = require("../../../assets/icon/at.svg");
var tim_1 = require("../../../../TUICore/tim");
var core_1 = require("@vueuse/core");
var MessageInputAt = vue_1.ref();
var showAtList = vue_1.ref(false);
var allMemberList = vue_1.ref();
var showMemberList = vue_1.ref();
var position = vue_1.ref({
    left: 0,
    top: 0,
});
var command = vue_1.ref();
var selectedIndex = vue_1.ref(0);
var memberListItems = vue_1.ref();
var isH5 = vue_1.ref(false);
var MessageInputAtSuggestion = function () {
    return {
        allowedPrefixes: null,
        items: function (props) {
            var _a;
            var queryResult = (_a = allMemberList === null || allMemberList === void 0 ? void 0 : allMemberList.value) === null || _a === void 0 ? void 0 : _a.filter(function (item) {
                var _a, _b, _c, _d, _e, _f;
                return ((_b = (_a = item === null || item === void 0 ? void 0 : item.nick) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.startsWith((_c = props === null || props === void 0 ? void 0 : props.query) === null || _c === void 0 ? void 0 : _c.toLowerCase())) || ((_e = (_d = item === null || item === void 0 ? void 0 : item.userID) === null || _d === void 0 ? void 0 : _d.toLowerCase()) === null || _e === void 0 ? void 0 : _e.startsWith((_f = props === null || props === void 0 ? void 0 : props.query) === null || _f === void 0 ? void 0 : _f.toLowerCase()));
            });
            showMemberList.value = (queryResult === null || queryResult === void 0 ? void 0 : queryResult.length) ? queryResult : allMemberList.value;
            return showMemberList.value;
        },
        render: function () {
            return {
                onStart: function (props) {
                    showAtList.value = true;
                    if (!(props === null || props === void 0 ? void 0 : props.clientRect)) {
                        return;
                    }
                    var rect = props === null || props === void 0 ? void 0 : props.clientRect();
                    if ((rect === null || rect === void 0 ? void 0 : rect.left) && (rect === null || rect === void 0 ? void 0 : rect.top) && !isH5.value) {
                        position.value = {
                            left: rect === null || rect === void 0 ? void 0 : rect.left,
                            top: rect === null || rect === void 0 ? void 0 : rect.top,
                        };
                    }
                    command.value = props.command;
                },
                onUpdate: function (props) {
                    if (!(props === null || props === void 0 ? void 0 : props.clientRect)) {
                        return;
                    }
                    var rect = props === null || props === void 0 ? void 0 : props.clientRect();
                    if ((rect === null || rect === void 0 ? void 0 : rect.left) && (rect === null || rect === void 0 ? void 0 : rect.top) && !isH5.value) {
                        position.value = {
                            left: rect === null || rect === void 0 ? void 0 : rect.left,
                            top: rect === null || rect === void 0 ? void 0 : rect.top,
                        };
                    }
                },
                onKeyDown: function (props) {
                    var _a, _b;
                    if (props.event.key === "Enter") {
                        (_a = props.event) === null || _a === void 0 ? void 0 : _a.stopPropagation();
                        (_b = props.event) === null || _b === void 0 ? void 0 : _b.preventDefault();
                    }
                    if (props.event.key === "Escape") {
                        showAtList.value = false;
                        showMemberList.value = allMemberList.value;
                        return true;
                    }
                    if ((props === null || props === void 0 ? void 0 : props.event.key) === "ArrowUp") {
                        upHandler();
                        return true;
                    }
                    if ((props === null || props === void 0 ? void 0 : props.event.key) === "ArrowDown") {
                        downHandler();
                        return true;
                    }
                    if ((props === null || props === void 0 ? void 0 : props.event.key) === "Enter") {
                        enterHandler();
                        return true;
                    }
                    return false;
                },
                onExit: function (props) {
                    showAtList.value = false;
                    showMemberList.value = allMemberList.value;
                    position.value = {
                        left: 0,
                        top: 0,
                    };
                },
            };
        },
    };
};
exports.MessageInputAtSuggestion = MessageInputAtSuggestion;
var upHandler = function () {
    var _a, _b, _c, _d;
    if (!((_a = showMemberList === null || showMemberList === void 0 ? void 0 : showMemberList.value) === null || _a === void 0 ? void 0 : _a.length))
        return;
    selectedIndex.value = (selectedIndex.value + ((_b = showMemberList === null || showMemberList === void 0 ? void 0 : showMemberList.value) === null || _b === void 0 ? void 0 : _b.length) - 1) % ((_c = showMemberList === null || showMemberList === void 0 ? void 0 : showMemberList.value) === null || _c === void 0 ? void 0 : _c.length);
    (_d = memberListItems === null || memberListItems === void 0 ? void 0 : memberListItems.value[selectedIndex.value]) === null || _d === void 0 ? void 0 : _d.scrollIntoView(false);
};
var downHandler = function () {
    var _a, _b, _c;
    if (!((_a = showMemberList === null || showMemberList === void 0 ? void 0 : showMemberList.value) === null || _a === void 0 ? void 0 : _a.length))
        return;
    selectedIndex.value = (selectedIndex.value + 1) % ((_b = showMemberList === null || showMemberList === void 0 ? void 0 : showMemberList.value) === null || _b === void 0 ? void 0 : _b.length);
    (_c = memberListItems === null || memberListItems === void 0 ? void 0 : memberListItems.value[selectedIndex.value]) === null || _c === void 0 ? void 0 : _c.scrollIntoView(false);
};
var enterHandler = function () {
    selectItem(selectedIndex.value);
};
var selectItem = function (index) {
    var _a, _b, _c, _d;
    if (!((_a = showMemberList === null || showMemberList === void 0 ? void 0 : showMemberList.value) === null || _a === void 0 ? void 0 : _a.length))
        return;
    var item = showMemberList === null || showMemberList === void 0 ? void 0 : showMemberList.value[index];
    if (item) {
        command.value &&
            command.value({
                id: (_b = item) === null || _b === void 0 ? void 0 : _b.userID,
                label: ((_c = item) === null || _c === void 0 ? void 0 : _c.nick) || ((_d = item) === null || _d === void 0 ? void 0 : _d.userID),
            });
    }
};
var MessageInputAtComponent = vue_1.defineComponent({
    props: {
        memberList: {
            type: Array,
            default: function () { return []; },
        },
        isGroup: {
            type: Boolean,
            default: false,
        },
        selfInfo: {
            type: Object,
            default: function () { return ({}); },
        },
        isH5: {
            type: Boolean,
            default: false,
        },
    },
    setup: function (props) {
        var _a = vue_1.toRefs(props), memberList = _a.memberList, isGroup = _a.isGroup, selfInfo = _a.selfInfo;
        var all = {
            userID: tim_1.default.TYPES.MSG_AT_ALL,
            nick: "所有人",
            isAll: true,
            avatar: at_svg_1.default,
        };
        var dialog = vue_1.ref();
        vue_1.watchEffect(function () {
            showAtList.value = showAtList.value && isGroup.value;
            isH5.value = props.isH5;
        });
        vue_1.watch(function () { return memberList.value; }, function () {
            var _a, _b, _c;
            // add all
            if (!((_a = memberList === null || memberList === void 0 ? void 0 : memberList.value[0]) === null || _a === void 0 ? void 0 : _a.isAll)) {
                (_b = memberList === null || memberList === void 0 ? void 0 : memberList.value) === null || _b === void 0 ? void 0 : _b.unshift(all);
            }
            // delete self in @ list
            var list = (_c = memberList === null || memberList === void 0 ? void 0 : memberList.value) === null || _c === void 0 ? void 0 : _c.filter(function (item) {
                var _a;
                return (item === null || item === void 0 ? void 0 : item.userID) !== ((_a = selfInfo === null || selfInfo === void 0 ? void 0 : selfInfo.value) === null || _a === void 0 ? void 0 : _a.userID);
            });
            allMemberList.value = list;
            showMemberList.value = list;
        }, {
            deep: true,
            immediate: true,
        });
        vue_1.watch(function () { return [position.value, MessageInputAt === null || MessageInputAt === void 0 ? void 0 : MessageInputAt.value]; }, function () {
            var _a;
            if (isH5.value || !(MessageInputAt === null || MessageInputAt === void 0 ? void 0 : MessageInputAt.value) || !((_a = MessageInputAt === null || MessageInputAt === void 0 ? void 0 : MessageInputAt.value) === null || _a === void 0 ? void 0 : _a.style)) {
                return;
            }
            MessageInputAt.value.style.left = position.value.left + "px";
            MessageInputAt.value.style.top = position.value.top - MessageInputAt.value.clientHeight + "px";
        }, {
            deep: true,
            immediate: true,
        });
        var closeAt = function () {
            showAtList.value = false;
            showMemberList.value = allMemberList.value;
            position.value = {
                left: 0,
                top: 0,
            };
        };
        core_1.onClickOutside(dialog, function () {
            closeAt();
        });
        return {
            selectedIndex: selectedIndex,
            selectItem: selectItem,
            showAtList: showAtList,
            closeAt: closeAt,
            showMemberList: showMemberList,
            allMemberList: allMemberList,
            MessageInputAt: MessageInputAt,
            memberListItems: memberListItems,
            dialog: dialog,
        };
    },
});
exports.MessageInputAtComponent = MessageInputAtComponent;
exports.default = MessageInputAtComponent;
